<mat-paginator
  [length]="paginator.length"
  [pageIndex]="paginator.pageIndex"
  [pageSize]="paginator.pageSize"
  [pageSizeOptions]="paginator.pageSizeOptions"
  (page)="onPage($event)">
</mat-paginator>
